import { inputFunc } from "../../lib/inputFunctions";
import "./input.css";
import "./dropdown.css";
import { useEffect, useRef, useState } from "react";

type TextInputProps = {
  state: { [key: string]: any };
  setState: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
  stateKey: string;
  list: { [key: string]: any }[];
  listKeys: string[];
  listTarget: string;
  handleClick?: any;
  label?: string;
  inlineLabel?: string;
  labelWidth?: number;
  placeholder?: string;
  required?: boolean;
};

export function Dropdown({
  state,
  stateKey,
  setState,
  list,
  listKeys,
  listTarget,
  handleClick,
  label,
  inlineLabel,
  labelWidth,
  placeholder,
  required
}: TextInputProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [active, setActive] = useState(false);
  const [selected, setSelected] = useState("");

  const onClickItem = (item: any, listKey: string, target: string) => {
    inputFunc.changeObj(item[target], setState, stateKey);
    setSelected(item[listKey]);
    handleClick && handleClick(item);
    setActive(false);
  };

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="input-container dropdown">
      {label && (
        <div className="input-label">
          <label>{label}</label>
        </div>
      )}
      <div className="input-wrapper">
        {inlineLabel && (
          <div style={{ width: labelWidth }} className="input-inline-label">
            {inlineLabel}
          </div>
        )}
        <div className="inputfield-wrapper">
          <input
            id={stateKey}
            name={stateKey}
            className={`inputfield ${inlineLabel && "inlinelabeled"}`}
            type="text"
            value={selected}
            placeholder={placeholder}
            required={required}
            readOnly
            onClick={() => setActive(active ? false : true)}
          />
        </div>
        <div className="input-after" onClick={() => setActive(active ? false : true)}>
          {
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
              <path d="M480-360 280-560h400L480-360Z" />
            </svg>
          }
        </div>
      </div>
      {list.length > 0 && (
        <div className={`dropdown-menu ${active ? "open" : ""}`}>
          <div
            className="dropdown-item"
            onClick={() => {
              inputFunc.changeObj("", setState, stateKey);
              setSelected("");
              setActive(false);
            }}
          >
            -- {label || inlineLabel || placeholder} --
          </div>

          {list.map((item: any, index: number) => (
            <div key={index} className="dropdown-item" onClick={() => onClickItem(item, listKeys[0], listTarget)}>
              {listKeys.map((e, i) => (
                <div key={i} style={{ display: "inline-block", marginRight: 5 }}>
                  {item[e]}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
